<template>
  <div class="surface-sample-table-overview">
    <div class="overview-table-row">
      <div class="overview-table">
        <MeasurementObjectsSelectTable
          :projectId="$route.params.projectId"
          :updateSelectedRows="() => {}"
          :enableColumnChooser="enableColumnChooser"
          :searchPanelEnabled="searchPanelEnabled"
          @update:selected="onUpdateMeasurementObject"
        />
      </div>
      <div class="overview-table">
        <AirSamplesTable
          :projectId="$route.params.projectId"
          :projectCode="projectCode"
          :selectedMeasurementObject="measurementObject"
          :updateSelectedRows="onUpdateAirSample"
          :enableCreateTableRowAction="enableCreateTableRowAction"
          :enableDeleteTableRowAction="enableDeleteTableRowAction"
          :enableUpdateTableRowAction="enableUpdateTableRowAction"
          :enableColumnChooser="enableColumnChooser"
          :searchPanelEnabled="searchPanelEnabled"
          :enableExportSettings="enableExportSettings"
          sampleType="Surface"
        />
      </div>
      <div class="overview-table">
        <PackagingsTable
          :projectId="$route.params.projectId"
          :projectCode="projectCode"
          :selectedMeasurementObject="measurementObject"
          :selectedAirSample="airSample"
          :enableCreateTableRowAction="enableCreateTableRowAction"
          :enableDeleteTableRowAction="enableDeleteTableRowAction"
          :enableUpdateTableRowAction="enableUpdateTableRowAction"
          :enableColumnChooser="enableColumnChooser"
          :searchPanelEnabled="searchPanelEnabled"
          :enableExportSettings="enableExportSettings"
        />
      </div>
    </div>
    <div class="overview-table-row">
      <div class="overview-table">
        <WaterSamplesTable
          :projectId="$route.params.projectId"
          :projectCode="projectCode"
          :selectedMeasurementObject="measurementObject"
          :updateSelectedRows="onUpdateWaterSample"
          :enableCreateTableRowAction="enableCreateTableRowAction"
          :enableDeleteTableRowAction="enableDeleteTableRowAction"
          :enableUpdateTableRowAction="enableUpdateTableRowAction"
          :enableColumnChooser="enableColumnChooser"
          :searchPanelEnabled="searchPanelEnabled"
          :enableExportSettings="enableExportSettings"
          sampleType="Surface"
        />
      </div>
      <div class="overview-table">
        <BottlesTable
          :projectId="$route.params.projectId"
          :projectCode="projectCode"
          :selectedMeasurementObject="measurementObject"
          :selectedWaterSample="waterSample"
          :enableCreateTableRowAction="enableCreateTableRowAction"
          :enableDeleteTableRowAction="enableDeleteTableRowAction"
          :enableUpdateTableRowAction="enableUpdateTableRowAction"
          :enableColumnChooser="enableColumnChooser"
          :searchPanelEnabled="searchPanelEnabled"
          :enableExportSettings="enableExportSettings"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {
  MeasurementObjectsSelectTable,
  AirSamplesTable,
  WaterSamplesTable,
  BottlesTable,
  PackagingsTable
} from '@/components/dynamicTables/tables'
import Popup from '@/utils/popup'
import Config from '@/configurations/config'
import stringUtils from '@/utils/stringUtils'

const TiPopup = Popup[Config.platform].default

export default {
  name: 'SurfaceSamplesTableOverview',
  components: {
    MeasurementObjectsSelectTable,
    AirSamplesTable,
    WaterSamplesTable,
    BottlesTable,
    PackagingsTable
  },
  props: {
    enableCreateTableRowAction: {
      required: false,
      default() {
        return true
      }
    },
    enableDeleteTableRowAction: {
      required: false,
      default() {
        return true
      }
    },
    enableUpdateTableRowAction: {
      required: false,
      default() {
        return true
      }
    },
    enableColumnChooser: {
      required: false,
      default() {
        return true
      }
    },
    searchPanelEnabled: {
      required: false,
      default() {
        return true
      }
    },
    enableExportSettings: {
      required: false,
      default() {
        return true
      }
    }
  },
  data() {
    return {
      measurementObject: {},
      airSample: {},
      waterSample: {},
      projectCode: ''
    }
  },
  async created() {
    await this.setCurrentProject()
  },
  methods: {
    async onUpdateMeasurementObject(data) {
      // if (data && Array.isArray(data) && data.length === 1) {
      //   this.measurementObject = data[0]
      // } else {
      //   this.measurementObject = {}
      // }
      this.measurementObject = data
    },
    async onUpdateAirSample(data) {
      if (data && Array.isArray(data) && data.length === 1) {
        this.airSample = data[0]
      } else {
        this.airSample = {}
      }
    },
    async onUpdateWaterSample(data) {
      if (data && Array.isArray(data) && data.length === 1) {
        this.waterSample = data[0]
      } else {
        this.waterSample = {}
      }
    },
    async setCurrentProject() {
      if (stringUtils.isNullOrEmptyOrWhitespace(this.$route.params.projectId)) {
        TiPopup.popup(this.$t('message.projectNotFound'))
        return
      }

      await this.$store.dispatch('fetchProject', {
        PrID: this.$route.params.projectId
      })
      const project = this.$store.state.currentProject

      if (project && project.PrID) {
        this.projectCode = project.PrCode
      } else {
        TiPopup.popup(this.$t('message.projectNotFound'))
      }
    },
    async handleErrorResponse(error, errorMessage = 'message.UnknownError') {
      console.log(error)
      TiPopup.popup(this.$t(errorMessage))
    }
  }
}
</script>

<style>
.surface-sample-table-overview h2 {
  margin-top: 5px;
  font-size: 20px;
}
.surface-sample-table-overview {
  height: 100%;
}
.surface-sample-table-overview .overview-table-row {
  height: 50%;
}
.surface-sample-table-overview .overview-table-row {
  display: flex;
}
.surface-sample-table-overview
  .overview-table-row:first-child
  .overview-table:first-child {
  flex: 2;
}
.surface-sample-table-overview
  .overview-table-row:first-child
  .overview-table:nth-child(2) {
  flex: 4;
}
.surface-sample-table-overview
  .overview-table-row:first-child
  .overview-table:nth-child(3) {
  flex: 3;
}
.surface-sample-table-overview
  .overview-table-row:nth-child(2)
  .overview-table:first-child {
  flex: 6;
}
.surface-sample-table-overview
  .overview-table-row:nth-child(2)
  .overview-table:nth-child(2) {
  flex: 3;
}
.surface-sample-table-overview .overview-table-row .overview-table > div {
  margin-left: 10px;
}
.surface-sample-table-overview .overview-table-row:nth-child(2) {
  padding-top: 10px;
}
.surface-sample-table-overview .overview-table {
  overflow: hidden;
}
.surface-sample-table-overview .overview-table > div,
.surface-sample-table-overview .overview-table > div > div {
  height: 100%;
}
.surface-sample-table-overview .overview-table-row .overview-table > div,
.surface-sample-table-overview .overview-table-row .overview-table > div > div {
  height: 100%;
}
.dx-datagrid-search-panel {
  margin-left: 0px;
}
</style>
